const routes = {
    landing: "/"
};

// ----------------------------------------------------------------------

export default routes;
